import mainTheme from '@/themes/main-theme'
import lightTheme from '@/themes/light-theme'

export default {
  namespaced: true,

  state: {
    name: 'main',
    values: mainTheme
  },

  mutations: {
    switchTheme (state) {
      if (state.name === 'main') {
        state.name = 'light'
        state.values = lightTheme
      } else {
        state.name = 'main'
        state.values = mainTheme
      }
    }
  }
}
